import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";

export default {
    getAllOperationEntitiesForDropDown,
    saveWeighPoint,
    getAllCollectionPointsByFilter,
    editWeighPoint
};


async function getAllCollectionPointsByFilter(data) {
    let filter = {
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID:parseInt(data.collectionCatagoryID),
        groupID: parseInt(data.groupID)
    } 
    const response = await CommonPost('/api/CollectionPoint/GetCollectionPointByFilter', null, filter);
   return response.data;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function saveWeighPoint(data){
    let route = {
        collectionPointID: 0,
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation.trim(),
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID:parseInt(data.collectionCategoryID),
        collectionPointCategoryID:3,
        operationEntityTypeID: 1,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        groupID: parseInt(data.groupID)
    }
    const response = await CommonPost('/api/CollectionPoint/SaveWeighPoint', null, route);
    return response;
}

async function editWeighPoint(data){
    let route = {
        collectionPointID: data.collectionPointID,
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation.trim(),
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID:parseInt(data.collectionCategoryID),
        collectionPointCategoryID:3,
        operationEntityTypeID: 1,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        groupID: parseInt(data.groupID)
    }
    const response = await CommonPost('/api/CollectionPoint/UpdateFactoryWeighPoint', null, route);
    return response;
}